import React, { Component } from 'react'
import 'tabler-react/dist/Tabler.css'
import './App.scss'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import { Site } from 'tabler-react'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'
import store from './shared/store'
// import Request from './shared/request';
import footerProps from './pages/Partials/Footer'
import header from './pages/Partials/Header'
import Home from './pages/Home'
import ResetPassword from './pages/Settings/ResetPassword'
import EmailConfirm from './pages/Settings/EmailConfirm'
import Subscribe from './pages/Settings/Subscribe'
import WechatBind from './pages/Settings/WechatBind'
import Affiliate from './pages/Affiliate'
import Ticket from './pages/Ticket'
import Vas from './pages/Vas'
import Account from './pages/Account'
import AccountSetPassword from './pages/Account/SetPassword'
import AccountBindEmail from './pages/Account/AccountBindEmail'
import Login from './pages/Login'
import AutoLogin from './pages/Login/autoLogin'
import Forgot from './pages/Forgot'
import Bind from './pages/Bind'
import Order from './pages/Order'
import AppSearch from './pages/Admin/app-search'
import 'remixicon/fonts/remixicon.css'

const AuthRoute = props => {
  let token
  const search = new URLSearchParams(window.location.search)
  try {
    token = search.get('token') || Cookies.get('malus-token')
  } catch (err) {
    // noop
  }
  if (store.user) {
    return <Route {...props} />
  }
  const path =
    window.location.pathname.indexOf('logout') < 0
      ? window.location.pathname
      : '/dashboard'
  const hl = window.location.search.indexOf('hl=') > -1 ? `&hl=${search.get('hl')}` : ''
  if (token) {
    return (
      <Redirect
        to={`/dashboard/autologin?forward=${path}&token=${token}${hl}`}
        from={path}
      />
    )
  }
  return <Redirect to={`/dashboard/login?forward=${path}${hl}`} />
}

// eslint-disable-next-line react/prefer-stateless-function
export default class App extends Component {
  state = {
    headerProps: header.headerProps,
    navProps: header.navProps,
  };

  async componentDidMount() {
    await store.dispatch({ type: 'updateNotification' })
    const searchParams = new URLSearchParams(window.location.search)
    const lang = searchParams.get('hl')
    if (lang) {
      store.dispatch({ type: 'updateLang', payload: lang })
      const newUrl = window.location.href.replace(`hl=${lang}`, '')
      window.location.href = newUrl
      return
    }   
    
    const { headerProps } = this.state
    let messagesEl = [
      {
        message: <div className="notification-empty"> <i className="ri-inbox-line"></i> <span>暂无消息</span> </div>,
        time: '',
      },
    ]
    if (store.notifications && store.notifications.length > 0) {
      messagesEl = store.notifications.map(item => ({
        message: (
          <React.Fragment>
            {item.link ? (
              <a href={item.link} target="noopener noreferrer">
                {item.title}
              </a>
            ) : (
                item.title
              )}
          </React.Fragment>
        ),
        time: dayjs(item.pushAt).format('YYYY-MM-DD'),
      }))
    }
    this.setState({
      headerProps: {
        ...headerProps,
        notificationsTray: {
          notificationsObjects: messagesEl,
          markAllAsRead: () => { },
          // unread: 1,
        },
      },
    })
    try {
      document
        .querySelector('.fe-bell')
        .parentNode.classList.add('notification-bell')
    } catch (e) {
      // noop
    }
  }

  render() {
    const { headerProps, navProps } = this.state
    return (
      <div
        className={`${store.user ? store.user.plan : 'FREE'} ${store.user && store.user.isEdu ? 'edu' : ''
          } ${store.user ? store.user.userClassname : ''} lang-${store.lang.id}`}
        id="dashboard">
        <Router>
          <Switch>
            <Route path="/login" component={Login} />
            <Route path="/dashboard/admin/app-search" component={AppSearch} />
            <Route path="/dashboard/forgot" component={Forgot} />
            <Route path="/dashboard/login" component={Login} />
            <Route path="/dashboard/autologin" component={AutoLogin} />
            <Site.Wrapper
              footerProps={footerProps}
              headerProps={headerProps}
              navProps={navProps}>
              <AuthRoute path="/dashboard" exact component={Home} />
              <AuthRoute path="/home" exact component={Home} />
              <AuthRoute path="/dashboard/referral" component={Home} />
              <AuthRoute
                path="/dashboard/account-password"
                component={ResetPassword}
              />
              <AuthRoute path="/dashboard/email" component={EmailConfirm} />
              <AuthRoute path="/dashboard/wechat" component={WechatBind} />
              <AuthRoute path="/dashboard/subscribe" component={Subscribe} />
              <AuthRoute path="/dashboard/affiliate" component={Affiliate} />
              <AuthRoute path="/dashboard/ticket" component={Ticket} />
              <AuthRoute path="/dashboard/vas" component={Vas} />
              <AuthRoute path="/dashboard/account" component={Account} />
              <AuthRoute path="/dashboard/bind" component={Bind} />
              <AuthRoute path="/dashboard/order" component={Order} />
              <AuthRoute
                path="/dashboard/bind-email"
                component={AccountBindEmail}
              />
              <AuthRoute
                path="/dashboard/set-password"
                component={AccountSetPassword}
              />
            </Site.Wrapper>
          </Switch>
        </Router>
      </div>
    )
  }
}
